export default __webpack_public_path__ + "static/media/closeInput.260806fb.svg";